import React from 'react';

import Table from 'components/Table';
import Money from 'components/Money';

import './styles.css';

const ItemsTable = ({overpayment}) => {
  return (
    <div className="ItemsTable">
      <Table>
        <Table.Header>
          <Table.HeaderItem heading="Description" className="description" />
          <Table.HeaderItem heading="Amount" className="amount" />
          <Table.HeaderItem heading="Account" className="account" />
          <Table.HeaderItem heading="Tax rate" className="taxRate" />
          <Table.HeaderItem heading="Amount GBP" className="amountGbp" />
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell>{overpayment.description}</Table.Cell>
            <Table.Cell>
              <Money amount={overpayment.amount} />
            </Table.Cell>
            <Table.Cell>{overpayment.xeroAccount}</Table.Cell>
            <Table.Cell>No VAT</Table.Cell>
            <Table.Cell>
              <Money amount={overpayment.amount} />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </div>
  );
};

export default ItemsTable;
